import { ThemeProvider, useTheme } from 'styled-components';
import { TSize } from '../../tokens/types';
import React from 'react';

export interface SizeTheme {
    size: TSize;
}

export function useSize() {
    const size = (useTheme() as SizeTheme)?.size;

    if (!size) {
        throw new Error('useSize must be used within a ThemeProvider');
    }

    return size;
}

export function SizeProvider({
    size,
    children,
    additionalThemeProps
}: {
    size: TSize;
    children: React.ReactNode;
    additionalThemeProps: Record<string, any>;
}) {
    return (
        <ThemeProvider theme={{ size, ...additionalThemeProps }}>
            {children}
        </ThemeProvider>
    );
}
